import { otcOnlyRoles } from '@truepill/tpos-types'
import { usePlusClient } from 'providers/VisionRouter'

const useIsOtcOnlyUser = (): boolean => {
  const { tokenContext } = usePlusClient()

  return tokenContext?.hasRole?.(otcOnlyRoles) ?? false
}

export default useIsOtcOnlyUser
